export {
  axisTop,
  axisRight,
  axisBottom,
  axisLeft
} from "./src/axis";



// WEBPACK FOOTER //
// ./~/d3-axis/index.js